export const throwError = (error: unknown) => {
    throw error
}
